import { set } from 'lodash';
import { BSKT_MonHoc } from '../../services/mon-hoc/models/MonHocModels';
import { createSlice } from '@reduxjs/toolkit';

interface MonHocState {
    isShowCreateOrEditModal: boolean;
    isShowConfirmDeleteModal: boolean;
    createOrEditModel: BSKT_MonHoc;
    status: string;
    listData: BSKT_MonHoc[];
    selectedId: number | null;
}

const initialState: MonHocState = {
    isShowCreateOrEditModal: false,
    isShowConfirmDeleteModal: false,
    createOrEditModel: {
        ID_mon: 0,
        Ky_hieu: undefined,
        Ten_mon: undefined,
        So_tin_chi: 0,
        Ly_thuyet: 0,
        Thuc_hanh: 0
    },
    status: 'loading',
    selectedId: null,
    listData: []
};

const monHocSlice = createSlice({
    name: 'monHoc',
    initialState,
    reducers: {
        updateMonHocSuccess: (state, action) => {
            const updatedMonHoc = action.payload;

            const index = state.listData.findIndex((monHoc) => monHoc.ID_mon === updatedMonHoc.ID_mon);
            console.log('updateMonHocSuccess', updatedMonHoc, index);
            if (index !== -1) {
                state.listData[index] = updatedMonHoc;
            }
            state.isShowCreateOrEditModal = false;
        },
        deleteMonHocSuccess: (state, action) => {
            const idToDelete = action.payload;
            state.listData = state.listData.filter((monHoc) => monHoc.ID_mon !== idToDelete);
            state.isShowConfirmDeleteModal = false;
        },
        insertMonHocSuccess: (state, action) => {
            const newMonHoc = action.payload;
            state.listData.push(newMonHoc);
        },
        selectMonHoc: (state, action) => {
            state.selectedId = action.payload;
        },
        clearSelectedMonHoc: (state) => {
            state.selectedId = null;
        },
        resetMonHocState: (state) => {
            state.isShowCreateOrEditModal = initialState.isShowCreateOrEditModal;
            state.createOrEditModel = initialState.createOrEditModel;
            state.status = initialState.status;
            state.listData = initialState.listData;
            state.selectedId = initialState.selectedId;
        },
        setMonHocList: (state, action) => {
            state.listData = Array.isArray(action.payload) ? action.payload : [];
        },
        setMonHocStatus: (state, action) => {
            state.status = action.payload;
        },
        setMonHocCreateOrEditModel: (state, action) => {
            state.createOrEditModel = action.payload;
        },
        setMonHocShowCreateOrEditModal: (state, action) => {
            state.isShowCreateOrEditModal = action.payload;
        },
        setMonHocSelectedId: (state, action) => {
            state.selectedId = action.payload;
        },
        setMonHocShowConfirmDeleteModal: (state, action) => {
            state.isShowConfirmDeleteModal = !state.isShowConfirmDeleteModal;
            state.selectedId = action.payload;
        }
    }
});

export const {
    clearSelectedMonHoc,
    deleteMonHocSuccess,
    insertMonHocSuccess,
    resetMonHocState,
    selectMonHoc,
    setMonHocCreateOrEditModel,
    setMonHocList,
    setMonHocSelectedId,
    setMonHocShowCreateOrEditModal,
    setMonHocStatus,
    updateMonHocSuccess,
    setMonHocShowConfirmDeleteModal
} = monHocSlice.actions;

export const MonHocReducer = monHocSlice.reducer;
